import {
  RobotsRuleResponse,
  TechnicalRuleResponse,
  TechRuleFinding,
} from 'store/api/apiTypes';
import { normalizeTechnicalRuleFindings } from './technicalAccessibility';

import { isMaxScoreReached } from './ruleScoring';

export interface RuleStat {
  total: number;
  pass: number;
  needFix: number;
}

type TechnicalUnit = {
  score: number | null | undefined;
  maxScore: number | null | undefined;
};

const calculateRuleStat = (units: TechnicalUnit[]): RuleStat => {
  const pass = units.filter(unit =>
    isMaxScoreReached(unit.score, unit.maxScore)
  ).length;

  return {
    total: units.length,
    pass,
    needFix: units.length - pass,
  };
};

interface TechnicalStatsInput {
  robotsRuleData?: RobotsRuleResponse;
  llmsRuleData?: TechnicalRuleResponse;
  schemaRuleData?: TechnicalRuleResponse;
}

const mapFindingsToUnits = (
  findings: Record<string, TechRuleFinding>
): TechnicalUnit[] =>
  Object.values(findings).map(({ score, max_score }) => ({
    score,
    maxScore: max_score,
  }));

export const calculateTechnicalSectionStats = ({
  robotsRuleData,
  llmsRuleData,
  schemaRuleData,
}: TechnicalStatsInput): RuleStat => {
  const availableUnits = [
    ...(robotsRuleData
      ? [
          {
            score: robotsRuleData.score,
            maxScore: robotsRuleData.max_score,
          },
        ]
      : []),
    ...(llmsRuleData
      ? mapFindingsToUnits(
          normalizeTechnicalRuleFindings(llmsRuleData.findings, 'llms')
        )
      : []),
    ...(schemaRuleData
      ? mapFindingsToUnits(
          normalizeTechnicalRuleFindings(schemaRuleData.findings, 'schema')
        )
      : []),
  ];

  return calculateRuleStat(availableUnits);
};
